export default {
  cancelOrderMap:{
    "0": "Saya tidak menginginkannya.",
    "1": "Salah menempatkan produk",
    "2": "Pesanan duplikat",
    "3": "Penerimaan gagal",
    "4": "Alasan lain"
  },
  order: {
    cancel: "Batalkan pesanan",
    payment: "Bayar sekarang",
    confirm: "Konfirmasi penerimaan",
    remind: "Mengingatkan untuk Pengiriman",
    return: "Permintaan pengembalian dana produk",
    evaluate: "Tinjau sekarang",
    logistics: "Lihat logistik",
    noRefund: "Tidak dapat dikembalikan",
    refunding: "Pengembalian dana sedang berlangsung",
    refundSuccess: "Pengembalian dana berhasil",
    refundFail: "Pengembalian dana gagal",
    remindTitle: "Mengingatkan untuk Pengiriman",
  },
  "暂无数据": "Tidak ada data",
  "加载中": "Memuat",
  "电商批发商场": "Mal Grosir",
  "热销推荐": "Penawaran Menarik",
  "用户未发表评论": "Pengguna belum berkomentar",
  "请输入关键字搜索": "Silakan masukkan kata kunci yang akan dicari",
  "请输入完整的支付密码!": "Silakan masukkan kata sandi pembayaran yang lengkap!",
  "subOrder": "Kirim",
  "KEY": "英语(en)",
  "-连接已建立-": "-Koneksi terjalin-",
  ",才可提币": ", dan kemudian uang tunai dapat ditarik.",
  "[code]值错误": "nilai [kode] salah",
  "[symbol]参数为空": "Parameter [simbol] kosong",
  "goodsFreightTips1": "1. Rumus Tarif Pengiriman Barang: Tarif pengiriman = Biaya pengiriman + Jarak + Biaya pengiriman",
  "creditQuotaINFO": "100.000 hingga 30.000.000 dengan limit fleksibel dan tanpa batasan, dengan jangka waktu pinjaman maksimal satu tahun.",
  "authentic": "100% Asli",
  "homeIconTips1": "100% Asli",
  "goodsFreightTips2": "2. Jika ketentuan ongkos kirim tidak terpenuhi, biaya pengiriman akan dibebankan sesuai dengan keadaan sebenarnya.",
  "goodsFreightTips3": "3. Hak interpretasi akhir adalah milik Platform.",
  "dayReturns7": "7 hari kembali",
  "homeIconTips2": "7 hari kembali",
  "homeIconTips4": "Pembayaran yang aman",
  "safe": "Aman dan Bebas Khawatir",
  "safePayment": "Pembayaran yang aman",
  "homeDownloadtips4": "Unduh untuk Android",
  "keep": "Menjaga",
  "saveQr": "Simpan kode QR",
  "payPal": "PayPal",
  "coinBlock": "Mata uang",
  "validatorRequire": "Bidang yang wajib diisi tidak boleh kosong",
  "edit": "Diedit oleh",
  "markDefaultAddress": "Tandai sebagai alamat Pengiriman default",
  "不能为空": "Itu tidak boleh kosong",
  "cancelOrder2": "Tidak suka, tidak menginginkannya",
  "contactUs1": "Jika Anda tidak ingin meminjam uang dari teman Anda, silakan hubungi kami.",
  "不在交易时段": "Keluar dari sesi perdagangan",
  "不在可提现时间内": "Di luar periode penarikan",
  "猜你喜欢": "Sepertinya kamu menyukainya",
  "paramError": "Kesalahan parameter",
  "参数错误": "Kesalahan parameter",
  "参数异常，消息获取失败": "Kesalahan parameter. Gagal menerima pesan",
  "Operate": "Operasi",
  "operationSuccess": "Operasi berhasil",
  "操作成功": "Operasi berhasil",
  "操作类型不能小于0": "Jenis operasi tidak boleh kurang dari 0",
  "操作类型不是整数": "Jenis operasinya bukan bilangan bulat",
  "操作类型为空": "Jenis operasinya kosong",
  "view": "Melihat",
  "Checkorder": "Tampilan Pemesanan",
  "logistics": "Lihat logistik",
  "CheckDetails": "Melihat rincian",
  "lowOpinion": "Ulasan buruk",
  "产品不存在": "Produknya tidak ada",
  "产品剩余数量不足": "Jumlah produk yang tersisa tidak mencukupi",
  "interest": "Mengumpulkan bunga",
  "dealSuccess": "Berhasil",
  "successTips": "Berhasil",
  "beSeller": "Menjadi Penjual",
  "homeBannertips1": "Menjadi Penjual",
  "承兑商不存在": "Akseptor tidak ada",
  "orderCity": "Kota",
  "city": "Kota",
  "程序错误": "Kesalahan program",
  "持有币种不足": "Pendanaan tidak cukup",
  "recharge": "Menyetorkan",
  "rechargeSuccessful": "Setoran berhasil",
  "rechargeAddress": "Alamat Setoran",
  "rechargeMethod": "Modus Setoran",
  "rechargeRecord": "Catatan Setoran",
  "充值价值不得大于最大限额": "Jumlah Deposit tidak boleh melebihi kisaran batas maksimum",
  "充值价值不得小于最小限额": "Jumlah Deposit tidak boleh kurang dari kisaran batas minimum",
  "充值金额不能小于1": "Jumlah Deposit tidak boleh kurang dari 1 (termasuk dua angka desimal)",
  "充值链错误": "Kesalahan tautan setoran",
  "rechargeNum": "Jumlah Setoran",
  "充值数量不能小于等于0": "Jumlah Deposit tidak boleh kurang dari atau sama dengan 0",
  "rechargeTips": "Catatan Deposit: Mohon isi jumlah transfer dengan benar. Jika tidak, sistem mungkin gagal lulus persetujuan dan mempengaruhi kemajuan pengisian ulang.",
  "dealing": "Sedang dalam proses",
  "processing": "Sedang dalam proses",
  "ship": "Kapal",
  "creditText1": "Pinjaman Awal adalah untuk menghindari kesulitan meminjam uang",
  "businessloan": "Aplikasi Pinjaman Awal",
  "存在不同杠杆的持仓单": "Ada opsi leverage yang berbeda",
  "cancelOrder7": "Ada masalah yang signifikan",
  "存在重复的角色名称": "Nama peran duplikat",
  "大于最大采购数量": "Lebih dari jumlah pembelian maksimum",
  "代理层级错误": "Kesalahan agen",
  "delivered": "kiriman yang tertunda",
  "pendingPayment": "Pembayaran tertunda",
  "待付款的订单无法放行": "Tidak dapat melepaskan pembayaran yang tertunda",
  "comment": "Untuk ditinjau",
  "receipt": "Untuk diterima",
  "pending": "Pembayaran tertunda",
  "loanHistory": "Catatan Pinjaman",
  "rates": "Suku Bunga Pinjaman",
  "term": "Ketentuan Pinjaman",
  "application": "Permohonan pinjaman",
  "creditWorry": "Pinjaman tanpa rasa khawatir",
  "orderUnitprice": "Harga satuan",
  "当前地址格式错误": "Alamat saat ini dalam format yang salah",
  "当前订单不为待付款状态，无法取消": "Pesanan saat ini tidak dalam status tertunda. Itu tidak dapat dibatalkan.",
  "当前还需交易": "Transaksi masih diperlukan",
  "currentRate": "Nilai tukar saat ini",
  "sure": "Tentu saja",
  "当日才可申购": "Hanya tersedia untuk pembelian pada hari yang sama",
  "当日可提现次数不足": "Jumlah tarik tunai per hari tidak mencukupi",
  "receivedAddress": "Alamat penerima",
  "orderAddress": "Alamat",
  "登陆密码不符合设定": "Kata sandi salah",
  "登陆密码长度不符合设定": "Kata sandi salah",
  "login": "Gabung",
  "loginIn": "Gabung",
  "signIn": "Gabung",
  "loginSuccess": "Berhasil",
  "登录过期，请重新登录": "Sesi telah berakhir. Silakan masuk lagi",
  "LoginPassword": "Kata sandi masuk",
  "登录密码必须6-12位": "Kata sandi harus terdiri dari 6-12 karakter",
  "登录密码不能为空": "Bidang ini tidak boleh kosong",
  "登录失败": "Gagal untuk masuk",
  "clickUpload": "Klik untuk mengunggah",
  "phoneNumber": "Nomor handphone",
  "电话号码已绑定": "Nomor ponsel sudah terhubung",
  "电话号码已绑定其他用户": "Nomor ponsel sudah tertaut ke pengguna lain",
  "email": "Surel",
  "shopCollection": "Tambahkan toko ke favorit",
  "订单": "Memesan",
  "trackOrder": "Memesan",
  "订单不存在": "Perintahnya tidak ada",
  "orderTrack": "Permintaan Pesanan",
  "serialNumber": "Nomor pesanan.",
  "orderSummary": "Jumlah Pesanan",
  "cancelOrderSuccess": "Pesanan yang Dibatalkan",
  "订单退款成功": "Pesanan yang Dikembalikan Dananya",
  "订单退款失败": "Pesanan Gagal untuk Pengembalian Dana",
  "orderDetails": "Detail pesanan",
  "orderInfo": "informasi pemesanan",
  "订单已签收": "Pesanan telah diterima",
  "订单已取消": "Pesanan telah dibatalkan",
  "订单已取消，无法放行": "Pesanan telah dibatalkan dan tidak dapat dilepaskan",
  "订单已取消，原因:超时自动取消订单": "Pesanan telah dibatalkan secara otomatis karena berakhirnya masa tunggu",
  "订单已取消，原因:手动发起取消订单": "Pesanan telah dibatalkan secara manual",
  "订单已完成": "Pesanan telah selesai",
  "订单已完成，无法放行": "Pesanan telah selesai dan tidak dapat dilepaskan",
  "moneyOrderStatus": "Status pemesanan",
  "orderPrefix": "Jumlah Pesanan",
  "subscription": "Langganan",
  "aboutText2": "Batas: 100.000-30.000.000, metode pembayaran fleksibel dengan bunga rendah, tanpa biaya di muka, pinjaman online, tanpa panggilan telepon untuk verifikasi, informasi rahasia, dan pinjaman di hari yang sama.",
  "additional": "Lagi",
  "evaluateOrderSuccess": "Peninjauan berhasil",
  "goodsShip": "Pengiriman",
  "发起退款申请": "Permintaan pengembalian dana",
  "send": "Mengirim",
  "发现新版本，请升级到最新版本": "Menemukan versi baru, harap tingkatkan ke versi terbaru",
  "visitStore": "Kunjungi Toko",
  "collAccount": "Metode Pinjaman",
  "loanMethod": "Metode Pinjaman",
  "classification": "Kategori",
  "服务器错误": "Server error",
  "服务器错误(500)": "Kesalahan server (500)",
  "servicePolicy": "Kebijakan layanan",
  "PaymentOrder": "Perintah pembayaran",
  "uploadTips": "Bukti pembayaran (Unggah tangkapan layar rincian pembayaran)",
  "copy": "Menyalin",
  "copySuccess": "Berhasil disalin",
  "该产品未上架": "Produk ini tidak terdaftar",
  "该产品已上市，无法购买": "Produk ini ada di pasaran dan tidak dapat dibeli",
  "该订单已取消": "Pesanan ini sudah dibatalkan",
  "remindRepeat": "Perintah ini telah diingatkan",
  "该广告剩余数量不足": "Jumlah iklan yang tersisa tidak mencukupi",
  "该基金尚未开放购买": "Dana tersebut belum dibuka untuk pembelian",
  "该基金尚已封闭": "Dana telah ditutup",
  "productAvailable": "Produk ini telah dihapus",
  "该邮箱已被订阅": "Email ini sudah berlangganan",
  "notOpen": "Metode pembayaran ini tidak terbuka untuk wilayah Anda",
  "格式有误:充值金额不能小于1(包含俩位小数)": "Formatnya salah: Jumlah Deposit tidak boleh kurang dari 1 (termasuk dua angka desimal)",
  "userCenter": "Pusat Pribadi",
  "Item": "Barang",
  "跟单倍数输入错误": "Kesalahan masukan ganda",
  "跟单参数输入错误": "Kesalahan masukan ganda",
  "more": "Lagi",
  "更新提醒": "Perbarui pengingat",
  "工作地址不能为空": "Bidang ini tidak boleh kosong",
  "homeBannertips2": "Jumlah Komisi",
  "orderTotal": "Total",
  "buyHistory": "Catatan Pembelian",
  "购买矿机时间不得低于托管订单剩余时间": "Waktu pembelian mesin penambangan tidak boleh kurang dari sisa waktu pemesanan hosting",
  "purchageHistory": "Riwayat Pembelian",
  "addCartMessageFaild": "Produk sudah ada di keranjang belanja Anda",
  "fixedRate": "Suku bunga tetap",
  "aboutUs": "Tentang kami",
  "about": "Tentang kami",
  "followers": "Mengikuti",
  "当前余额": "Saldo saat ini",
  "followedSuccess": "Berhasil",
  "myFollowedShops": "Ikuti tokonya",
  "广告不存在": "Iklannya tidak ada",
  "广告已下架": "Iklan tersebut telah dihapus",
  "orderSpecification": "Spesifikasi",
  "countryOf": "Kebangsaan",
  "areaCode": "Kode Area Internasional",
  "App下载(买家端)": "Unduhan Aplikasi (Pembeli)",
  "App下载(卖家端)": "Unduhan Aplikasi (Penjual)",
  "orderNation": "Negara",
  "nation": "Negara",
  "repayment": "Pembayaran kembali",
  "repay": "Metode pembayaran",
  "reAmount": "Jumlah pembayaran kembali",
  "cycle": "Siklus pembayaran kembali",
  "loginTips": "Tidak punya nomor rekening?",
  "noAccount": "Tidak punya nomor rekening?",
  "NoProductSelected": "Belum ada produk yang dipilih",
  "shipping": "Pengiriman",
  "highOpinion": "Ulasan bagus",
  "favorableRate": "Tingkat ulasan bagus",
  "myPraiseRate": "Tingkat ulasan bagus",
  "totalNum": "Total",
  "partner": "Pemasok koperasi",
  "partnersTit": "Mitra - Platform Pinjaman Online",
  "BackHome": "Kembali ke halaman Beranda",
  "or": "atau",
  "freight": "Muatan",
  "orderFreight": "Muatan",
  "getCoupons": "Dapatkan Lebih Banyak Kupon",
  "基金剩余购买金额不足": "Jumlah sisa pembelian dana tidak mencukupi",
  "quickLoan": "Pinjaman cepat",
  "records": "Catatan",
  "proceed": "Melanjutkan",
  "storeSeachTips3": "Rumah",
  "家庭地址不能为空": "Bidang ini tidak boleh kosong",
  "cancelOrder4": "Merek palsu",
  "price": "Harga",
  "piece": "buah",
  "transactionPassword": "Kata sandi transaksi",
  "交易员不存在": "Penjualnya tidak ada",
  "交易员不能跟随自己": "Penjual tidak bisa mengikuti dirinya sendiri",
  "交易员跟随人数已满": "Jumlah pedagang yang mengikuti sudah penuh",
  "交易员未开启带单": "Penjual belum membuka pesanan",
  "交易员无法跟随另一个交易员": "Penjual tidak dapat mengikuti penjual lain",
  "角色被用户关联，不可删除": "Peran dikaitkan oleh pengguna. Itu tidak dapat dihapus",
  "角色不存在": "Peran tidak ada",
  "receiver": "Penerima",
  "financial": "Selesaikan masalah keuangan Anda",
  "successLoan": "Proses peminjaman selesai dengan sukses",
  "borrow": "Proses peminjaman gagal diselesaikan",
  "loanAgree": "Perjanjian Pinjaman",
  "amount": "Jumlah",
  "金额不在购买区间": "Jumlahnya tidak dalam kisaran pembelian",
  "validatorMaxNumber": "Jumlahnya melebihi kisaran batas",
  "金额错误": "Kesalahan jumlah",
  "validatorChineseAndEnglish": "Hanya bahasa Cina dan Inggris yang didukung; konten inputnya 8-64 karakter",
  "oldPassword": "Password lama",
  "旧密码不能为空": "Bidang ini tidak boleh kosong",
  "旧密码不正确": "Kata sandi lama salah",
  "可平仓合约张数不足": "Jumlah kontrak posisi dekat tidak mencukupi",
  "service": "Pelayanan pelanggan",
  "custService": "Pelayanan pelanggan",
  "homeDownloadtips1": "Toko grosir e-commerce lintas batas",
  "矿机不存在": "Mesin penambangan tidak ada",
  "矿机未解锁，无法购买": "Mesin penambangan terkunci dan tidak dapat dibeli.",
  "From": "Dari",
  "历史基金无法购买": "Dana masa lalu tidak dapat dibeli",
  "historySearch": "Pencarian Sejarah",
  "payment": "Bayar sekarang",
  "buyNow": "Membeli sekarang",
  "homeBannerbtn": "Bergabung sekarang",
  "evaluate": "Tinjau sekarang",
  "连续输入错误三次，请3分钟后再试": "Input yang tidak valid terjadi tiga kali berturut-turut. Silakan coba lagi dalam 3 menit",
  "contactUs": "Hubungi kami",
  "twoPawword": "kata sandi tidak cocok",
  "creditQuota": "Rentang batas fleksibel",
  "retailPrice": "Harga eceran",
  "领取成功": "Berhasil diterima",
  "pageviews": "Jumlah penayangan",
  "myPageviews": "Jumlah penayangan",
  "buyRules": "Aturan Pembeli",
  "买入金额需要在区间内": "Jumlah pembelian harus berada dalam kisaran tersebut",
  "卖方无法取消该订单": "Penjual tidak dapat membatalkan pesanan",
  "cancelOrder3": "Penjual mengirimkan barang yang salah",
  "sellerRules": "Kebijakan Penjual",
  "noDataFound": "Tidak ada data ditemukan",
  "没有找到用户": "Tidak ada pengguna yang ditemukan",
  "dailyNewArrival": "Penawaran harian",
  "password": "Kata sandi",
  "密码必须6-12位": "Kata sandi harus terdiri dari 6-12 karakter",
  "密码不能为空": "Bidang ini tidak boleh kosong",
  "密码不正确": "Kata sandi salah",
  "wrongPassword": "Jumlah percobaan melebihi 3 kali. Silakan coba lagi besok",
  "validatorPassword": "Kata sandi harus terdiri dari 6-12 huruf dan angka (berisi karakter khusus)",
  "goodsFreeShipping": "Gratis",
  "orderName": "Nama",
  "defaultAddress": "Alamat bawaan",
  "noCartTips": "Keranjang belanja anda kosong. Mulailah berbelanja",
  "notLogin": "Anda belum masuk.",
  "unSelectedProduct": "Anda belum memilih produk apa pun",
  "evaluationUploading": "Gambar masih diunggah. Silakan coba lagi nanti",
  "您当前可分配额度不足": "Batas alokasi Anda saat ini tidak cukup",
  "yourEmail": "Alamat email anda",
  "您没有符合条件的收款方式": "Anda tidak memiliki metode pembayaran yang memenuhi syarat",
  "您已存在订单": "Anda punya pesanan",
  "您已购买过体验矿机,不得重复购买": "Anda telah membeli mesin penambangan pengalaman. Jangan membelinya lagi",
  "photoExample": "Contoh Foto",
  "homeDownloadtips2": "Merek sedang dijual",
  "Evaluate": "Ulasan",
  "evaluateOrder": "Ulasan dengan gambar",
  "evaluateInput": "Ulasan dengan gambar",
  "homeDownloadtips5": "Unduh untuk Apple",
  "cancelOrder9": "Alasan lain",
  "businessPhone": "Nomor Kontak Toko",
  "businessEmail": "Email Perusahaan",
  "walletHistory": "Sejarah Dompet",
  "亲属地址不能为空": "Bidang ini tidak boleh kosong",
  "亲属电话不能为空": "Bidang ini tidak boleh kosong",
  "亲属关系不能为空": "Bidang ini tidak boleh kosong",
  "亲属姓名不能为空": "Bidang ini tidak boleh kosong",
  "empty": "Kosong",
  "evaluateOrderPlaceholder": "Silakan tinjau produknya",
  "checkAgreement": "Mohon terima perjanjiannya!",
  "请检查网络连接": "Silakan periksa koneksi jaringan Anda",
  "returnDetailTips": "Tolong beri review tentang produknya",
  "switchLang": "Silakan beralih ke bahasa lain untuk memeriksa",
  "请切换其他语言后查看": "Silakan beralih ke bahasa lain untuk memeriksa",
  "请上传图片": "Silakan unggah gambar",
  "uploadPhoto": "Silakan unggah foto",
  "请稍后再试": "Silakan coba lagi nanti",
  "请稍后重试": "Silakan coba lagi nanti",
  "pleaseSetLoginPassword": "Silakan masukkan kata sandi masuk",
  "pleaseSetMobileNumber": "Silakan masukkan nomor ponsel",
  "pleaseEnterPhoneNumer": "Silakan masukkan nomor ponsel",
  "plaeseEnterInvitaionCode": "Silakan masukkan kode undangan",
  "pleaseEnterEmail": "Silakan masukkan emailnya",
  "enterTips": "Silakan masuk",
  "pleaseInput": "Silakan masuk",
  "validatorFourMoreNumber": "Silakan masukkan lebih dari 4 karakter",
  "pleaseValidPostCode": "Silakan masukkan lebih dari 4 karakter",
  "validatorSixNumber": "Silakan masukkan 6 karakter",
  "请输入充值币种": "Silakan masukkan mata uang Deposit",
  "plaseEnterRechargeAddress": "Silakan masukkan alamat penyetoran",
  "pleaseEnterAmount": "Silakan masukkan jumlah deposit",
  "pleaseInputCorrectNumber": "Silakan masukkan angka yang lebih besar dari 0",
  "pleaseEnterAddress": "Silakan masukkan alamatnya",
  "headerSearchTips": "Silakan masukkan kata kunci yang akan dicari",
  "pleaseEnterOldPassword": "Silakan masukkan kata sandi lama",
  "pleaseEnterPassword": "Silakan masukkan kata sandi",
  "请输入内容": "Silakan masukkan konten",
  "plaseeENterConfirmPassword": "Silakan masukkan kata sandi konfirmasi",
  "pleaseEnterQuantity": "Silakan masukkan jumlah",
  "请输入搜索关键字": "Silakan masukkan kata kunci yang akan dicari",
  "withdrawInputTips": "Silakan masukkan alamat penarikan",
  "plaseeEnterNewPassword": "Silakan masukkan kata sandi baru",
  "yourName": "Silakan masukkan namanya",
  "pleaseEnterAccount": "Silakan masukkan nomor rekening",
  "请输入正确的货币数量": "Silakan masukkan jumlah yang benar",
  "请输入正确的金额": "Silakan masukkan jumlah yang benar",
  "validatorPhone": "Silakan masukkan nomor ponsel yang benar",
  "pleaseValidPhone": "Silakan masukkan nomor ponsel yang benar",
  "请输入正确的数量": "Silakan masukkan jumlah yang benar",
  "inpuEmailErro": "Silakan masukkan alamat email yang benar",
  "pleaseValidEmail": "Silakan masukkan alamat email yang benar",
  "validatorEmail": "Silakan masukkan email dalam format yang benar",
  "请输入正确的质押金额": "Silakan masukkan jumlah kontribusi yang benar",
  "请输入正确的质押天数": "Silakan masukkan jumlah hari yang benar untuk melakukan kontribusi",
  "pleaseCorrectAddress": "Silakan masukkan alamat penarikan yang benar",
  "请填写正确的电话号码": "Silakan masukkan nomor ponsel yang benar",
  "请填写正确的验证码": "Silakan masukkan kode verifikasi yang benar",
  "mailboxCheck": "Silakan masukkan alamat email yang benar",
  "请填写正确的邮箱地址": "Silakan masukkan alamat email yang benar",
  "请先绑定谷歌验证器": "Harap ikat Google Authenticator terlebih dahulu",
  "请先添加收款方式": "Silakan tambahkan metode pembayaran terlebih dahulu",
  "请先通过高级认证": "Silakan lulus sertifikasi lanjutan terlebih dahulu",
  "cancelOrderTitle": "Silakan pilih alasan pembatalan pesanan",
  "selectCountry": "Silakan pilih kewarganegaraan",
  "请选择买卖方式": "Silakan pilih metode pembayaran",
  "selectPeriod": "Silakan pilih periode",
  "returnOrderTitle": "Silakan pilih alasan pengembalian",
  "请选择正确的币种": "Silakan pilih mata uang yang benar",
  "请重新登录": "Silakan masuk lagi",
  "blockchainNetwork": "jaringan blockchain",
  "渠道未开通": "Saluran tidak dibuka",
  "Cancel": "Membatalkan",
  "取消": "Membatalkan",
  "cancelSuccess": "Berhasil dibatalkan",
  "cancelOrder": "Batalkan pesanan",
  "cancel": "Batalkan pesanan",
  "CancelOrder": "Batalkan pesanan",
  "myUnfollow": "Berhenti mengikuti",
  "cancelReason": "Alasan Pembatalan",
  "all": "Lihat semua",
  "AllProducts": "Semua produk",
  "btnSure": "Mengonfirmasi",
  "确认": "Memeriksa",
  "entRepay": "Konfirmasi pembayaran",
  "confirmPayPaw": "Konfirmasikan kata sandi transaksi",
  "confirmPassword": "Konfirmasi sandi",
  "delAllHistoryRecord": "Apakah Anda yakin ingin menghapus semua catatan sejarah?",
  "confirm": "Konfirmasi penerimaan",
  "date": "Tanggal",
  "scanAndDown": "Pindai kode QR untuk mengunduh APLIKASI",
  "homeDownloadtips6": "Pindai kode QR untuk mengunduh APLIKASI",
  "delete": "Menghapus",
  "sellerPanelLogin": "Login penjual",
  "merchantSettled": "Kemitraan",
  "sellerZone": "Daerah pedagang",
  "商家已确认，已进入备货状态": "Penjual sudah dikonfirmasi dan sudah memulai proses stocking",
  "commodity": "Produk",
  "orderCommodity": "Produk",
  "commodityCollection": "Koleksi Produk",
  "productDescription": "Deskripsi Produk",
  "myCommodityCollection": "Produk Favorit",
  "goodsNumber": "Kuantitas Produk",
  "goodsShipTips": "Setelah melakukan pemesanan, itu akan dikirim dalam waktu 24 jam. Waktu pengiriman tergantung pada logistik dan mungkin memakan waktu lama. Harap perhatikan informasi logistik atau hubungi Layanan Pelanggan",
  "productInfo": "informasi produk",
  "uploadSuccess": "Berhasil diunggah",
  "uploadError": "Gagal mengunggah, silakan coba lagi",
  "uploading": "Mengunggah...",
  "upNew": "Produk baru",
  "previous": "Langkah sebelumnya",
  "prevPage": "Halaman sebelumnya",
  "cancelOrder5": "Pengiriman kurang, pengiriman terlewat",
  "desc": "Tetapkan sebagai alamat default",
  "setAsTheDefaultAddress": "Tetapkan sebagai alamat default",
  "setUp": "Mempersiapkan",
  "setSuccess": "Penyiapan berhasil",
  "setUpPayPaw": "Tetapkan kata sandi transaksi",
  "setPassword": "Tetapkan kata sandi",
  "申购数量错误": "Jumlah pembelian salah",
  "申请成功": "Berhasil",
  "applyLoan": "Ajukan pinjaman",
  "applicationAmount": "Jumlah yang diminta",
  "noSmaller": "Jumlah yang diminta tidak boleh kurang dari",
  "nomax": "Jumlah yang diminta tidak boleh melebihi",
  "applicant": "Pemohon",
  "applicantDate": "Tanggal Aplikasi",
  "return": "Permintaan pengembalian dana produk",
  "applicantIn": "Aplikasi sedang berlangsung",
  "身份证已实名过!": "KTP sudah terverifikasi!",
  "审核已通过": "Disetujui",
  "审核中": "Sedang ditinjau",
  "state": "Provinsi/Negara Bagian/Wilayah",
  "dealFail": "Gagal",
  "fail": "Gagal",
  "orderTime": "Waktu",
  "time": "Waktu",
  "ActualLedger": "Sebenarnya diterima",
  "actualAccount": "Akun sebenarnya",
  "实名认证未通过，无法进行高级认证": "Otentikasi gagal; tidak dapat melakukan otentikasi tingkat lanjut",
  "confirmReceiveGoods": "Konfirmasi penerimaan produk",
  "collect": "Favorit",
  "collectionSuccess": "Berhasil ditambahkan ke favorit",
  "wishlist": "Produk favorit",
  "cancelOrder6": "Menerima produk rusak",
  "desc5": "Alamat pengiriman salah? Kontak",
  "consigneeName": "Nama penerima",
  "shippingAddress": "Alamat penerima",
  "pleaseAddShippingAddress": "Silakan tambahkan alamat pengiriman terlebih dahulu",
  "收款方输入错误": "Kesalahan masukan",
  "购物车还没有商品": "Keranjang belanja anda kosong",
  "去购物": "Mulailah berbelanja",
  "mobile": "Nomor ponsel.",
  "mobilePhone": "Nomor handphone",
  "handleFee": "Biaya layanan",
  "handlingFee": "Biaya layanan",
  "home": "Rumah",
  "授权状态未成功": "Status otorisasi gagal",
  "pleaseSetAreaCode": "Masukkan nama negara dan kode area yang akan dicari",
  "searchCountry": "Masukkan nama negara dan kode area yang akan dicari",
  "desc3": "Masukkan kata sandi transaksi",
  "desc4": "Masukkan kata sandi transaksi Anda",
  "赎回状态异常": "Status penukaran tidak normal",
  "quantity": "Kuantitas",
  "orderAmount": "Kuantitas",
  "orderQuantity": "Kuantitas",
  "inputNum": "Angka",
  "orderTax": "Pajak",
  "orderFee": "Pajak",
  "tax": "Perpajakan",
  "delivery": "Pengiriman & pengumpulan",
  "storeSeach": "Cari produk di toko ini",
  "search": "Mencari",
  "所选汇率不存在": "Nilai tukar yang dipilih tidak ada",
  "allProduct": "Semua produk",
  "提币数量不能小于等于0": "Jumlah penarikan tidak boleh kurang dari atau sama dengan 0",
  "creditText2": "Menyediakan layanan pinjaman awal dan perputaran modal",
  "returnOrderSuccess": "Berhasil dikirimkan",
  "Submitareview": "Kirim ulasan",
  "submitApplica": "Kirimkan lamarannya",
  "提交失败": "Pengiriman Gagal",
  "提交失败，当前有未处理订单": "Pengiriman gagal. Saat ini ada pesanan terbuka",
  "hint": "Tip",
  "提示": "Tip",
  "withdraw": "Menarik",
  "提现不得大于限额": "Penarikan tunai tidak boleh lebih besar dari batasnya",
  "提现不得小于限额": "Penarikan tunai tidak boleh kurang dari batas",
  "withdrawSuccess": "Pesanan berhasil dikirim",
  "withdrawAddress": "Alamat penarikan",
  "withdrawRecord": "Catatan penarikan",
  "withdrawNum": "Kuantitas penarikan",
  "tipsRemindsSuccess": "Pengingat berhasil",
  "remindSuccess": "Pengingat berhasil",
  "RemindShip": "Ingatkan untuk mengirim",
  "remind": "Mengingatkan untuk Pengiriman",
  "remindTitle": "Mengingatkan untuk Pengiriman",
  "tipsRemindsText": "Setelah mengirimkan produk, penjual akan mendapat notifikasi",
  "remindContent": "Setelah mengirimkan produk, penjual hanya akan mendapat notifikasi satu kali",
  "tipsRemindsMerchant": "Ingatkan penjual",
  "days": "hari",
  "addCartMessage": "Berhasil ditambahkan ke keranjang belanja Anda",
  "addAddress": "Tambahkan alamat baru",
  "addAddressOrModifyAddress": "Tambahkan alamat baru/Ubah alamat",
  "addCart": "Tambahkan ke keranjang belanja",
  "图片不得大于10M": "Ukuran file untuk gambar tidak boleh lebih besar dari 10M",
  "图片不得大于2M": "Ukuran file untuk gambar tidak boleh lebih besar dari 2M",
  "图片大小不能超过2M！": "Ukuran file untuk sebuah gambar tidak boleh melebihi 2M!",
  "图片上传失败": "Gagal mengunggah gambar",
  "recommendclass": "Belanja berdasarkan Kategori",
  "recommend": "Menyarankan",
  "recommendedProducts": "Barang Populer",
  "recommendedStore": "Toko Populer",
  "推荐码不正确": "Kode rekomendasi salah",
  "推荐人无权限推荐": "Tidak ada otoritas untuk merekomendasikan",
  "推荐商品": "Barang Populer",
  "logout": "Keluar",
  "returnsAndEx": "Pengembalian dan Penukaran",
  "returnAmount": "Jumlah Pengembalian",
  "returnRemark": "Instruksi Pengembalian",
  "returnPolicy": "Kebijakan pengembalian",
  "Refund": "Pengembalian dana",
  "refund": "Pengembalian dana/purna jual",
  "退款成功": "Pengembalian dana berhasil",
  "refundSuccessfully": "Pengembalian dana berhasil",
  "refundSuccess": "Pengembalian dana berhasil",
  "returnReason": "Alasan Pengembalian Dana",
  "returnApply": "Permintaan pengembalian dana",
  "退款失败": "Pengembalian dana gagal",
  "refundFail": "Pengembalian dana gagal",
  "refundInstructions": "Instruksi Pengembalian Dana",
  "refunding": "Pengembalian dana sedang berlangsung",
  "mastercard": "MasterCard",
  "EsShop": "Toko online",
  "ForgotPassword": "Lupa password?",
  "委托数量(张)必填": "Kuantitas yang dipercayakan (pcs.) diperlukan",
  "委托数量(张)不能小于等于0": "Jumlah yang dipercayakan (pcs) tidak boleh kurang dari atau sama dengan 0",
  "foryourmoney": "Pinjaman online adalah pilihan mudah dan cepat untuk menyelesaikan masalah keuangan Anda. Anda tidak akan merasa malu seperti saat meminjam uang ke teman. Tim profesional kami akan membantu Anda menjalani proses dan menghilangkan keraguan Anda kapan saja. Kami bertujuan untuk memberikan setiap pinjaman kepada pelanggan kami dengan cepat, transparan dan aman.",
  "storeSeachTips1": "Temukan untukmu",
  "未绑定谷歌验证器": "Google Authenticator belum ditautkan",
  "未绑定手机号": "Nomor ponsel belum ditambahkan",
  "未绑定邮箱": "Emailnya belum ditambahkan",
  "未发现授权记录": "Catatan otorisasi belum ditemukan",
  "notQua": "Tidak memenuhi persyaratan",
  "ShippingAddressNotSet": "Alamat pengiriman belum ditetapkan",
  "未实名认证，是否认证？": "Tidak diautentikasi dengan nama asli. Otentikasi?",
  "cancelOrder1": "Produk belum diterima",
  "未授权访问": "Akses tidak sah",
  "noRefund": "Tidak dapat dikembalikan",
  "未找到符合条件的匹配订单": "Tidak ditemukan pesanan yang cocok",
  "未找到匹配的收益记录": "Tidak ditemukan catatan pendapatan yang cocok",
  "mine": "#NAME?",
  "myloan": "Pinjaman saya",
  "myOrder": "pesananku",
  "myCart": "Keranjang Belanja saya",
  "我的购物车": "Keranjang Belanja saya",
  "myPurse": "Dompetku",
  "myAccount": "Akun saya",
  "aboutText1": "“Kami memberikan layanan pinjaman berdasarkan filosofi bisnis Pelanggan adalah yang utama, yang bertujuan untuk menyelesaikan masalah keuangan modal pelanggan. Sejak perusahaan didirikan, kami telah membantu banyak pelanggan untuk menyelesaikan masalah perputaran modal mereka.",
  "readAndAgree": "Saya telah membaca dan menerima",
  "safeInfo": "Tidak memerlukan hipotek, tidak ada deposit, dan tidak ada panggilan balik. Ini adalah masalah pribadi.",
  "无权限": "tidak ada izin",
  "无效的UID": "UID tidak valid",
  "item": "Barang",
  "系统参数错误": "Kesalahan parameter sistem",
  "系统存在相同[系统登录名]！": "Pengguna lain sudah ada di sistem dengan nama login yang sama",
  "系统错误，请稍后重试": "Kesalahan sistem, silakan coba lagi nanti",
  "系统发货成功": "Berhasil",
  "系统默认好评": "Ulasan bagus secara default",
  "defaultRate": "Ulasan bagus secara default",
  "checkout": "Memesan",
  "下单不能小于最小金额限制": "Jumlah penempatan pesanan tidak boleh kurang dari batas minimum",
  "下单成功，等待付款": "Pesanan telah berhasil dilakukan, dan kami menunggu pembayarannya",
  "下单成功，付款成功": "Pembayaran berhasil",
  "buyTips": "Setelah melakukan pemesanan, pesanan akan dikirim dalam waktu 24 jam. Waktu pengiriman tergantung pada logistik dan mungkin memakan waktu lama. Harap perhatikan informasi logistik atau hubungi Layanan Pelanggan.",
  "nextPage": "Halaman selanjutnya",
  "stateMent": "Pernyataan Perbudakan Modern",
  "storeSeachTips2": "Toko terkait ditemukan",
  "address": "Alamat Lengkap",
  "items": "Barang",
  "browse": "Jumlah Penjualan",
  "sold": "Terjual",
  "sales": "Jumlah Penjualan",
  "校验IP不合法": "IP verifikasi tidak valid",
  "new": "Baru",
  "newPassword": "Kata sandi baru",
  "新密码不能为空": "Bidang ini tidak boleh kosong",
  "新密码不一致": "Kata sandinya tidak cocok",
  "新密码确认不能为空": "Bidang ini tidak boleh kosong",
  "news": "Berita",
  "addNewAddress": "Tambahkan alamat baru",
  "creditTit": "Layanan Pinjaman Kredit",
  "Information": "Informasi",
  "行情获取异常，稍后再试": "Kutipannya tidak normal, coba lagi nanti",
  "modifyAddress": "Ubah alamat",
  "handlingfee": "Biaya layanan diperlukan",
  "Opt": "Pilih",
  "selectDeliveryAddress": "Pilih alamat pengiriman",
  "验证类型不能为空": "Bidang ini tidak boleh kosong",
  "验证码不能为空": "Bidang ini tidak boleh kosong",
  "验证码不正确": "Kode verifikasi salah",
  "验证码错误": "Kesalahan kode verifikasi",
  "vcodeFail": "Verifikasi gagal, coba lagi",
  "vcodePass": "Diverifikasi!",
  "invitationCode": "Kode undangan",
  "页码不能小于等于0": "Nomor halaman tidak boleh kurang dari atau sama dengan 0",
  "页码不是整数": "Nomor halaman bukan bilangan bulat",
  "dashboard": "Dasbor",
  "loaned": "Dipinjamkan",
  "loanDays": "Durasi",
  "已发货，正在运输中": "Dikirim, dalam transportasi",
  "followed": "Diikuti",
  "repaid": "Pembayaran kembali",
  "已领取": "Diterima",
  "rated": "Ditinjau",
  "cancelled": "Dibatalkan",
  "confirmed": "Dikonfirmasi",
  "harvested": "Diterima",
  "mySold": "Terjual",
  "overdue": "Terlambat",
  "privacyPolicy": "Kebijakan pribadi",
  "用户不存在": "Pengguna tidak ada",
  "用户名必须由数字和英文字母组成": "Nama pengguna harus terdiri dari angka dan huruf",
  "用户名不存在": "Pengguna tidak ada",
  "用户名不符合设定": "Nama pengguna tidak cocok",
  "用户名不能为空": "Bidang ini tidak boleh kosong",
  "用户名参数为空": "Bidang ini tidak boleh kosong",
  "用户名重复": "Salin nama pengguna",
  "userEvaluation": "Ulasan Pengguna",
  "用户剩余数量不足": "Jumlah pengguna tidak mencukupi",
  "用户已跟随交易员": "Pengguna mengikuti toko",
  "user_Center": "Pusat Pengguna",
  "userReg": "pendaftaran pengguna",
  "postCode": "Kode Pos",
  "orderEmail": "Surel",
  "邮箱已绑定": "Email sudah dijilid",
  "邮箱已绑定其他用户": "Email telah terikat ke pengguna lain",
  "orderPostCode": "Kode Pos",
  "hasImage": "Dengan gambar",
  "Balance": "Keseimbangan",
  "balance": "Saldo (USDT)",
  "余额不足": "Saldo tidak mencukupi",
  "balanceNot": "Saldo tidak cukup, silakan deposit",
  "cancelOrder8": "Negosiasikan pengembalian dana dengan penjual",
  "expectedArrival": "Kedatangan yang diharapkan",
  "esRepayment": "Perkiraan pembayaran kembali",
  "estirepay": "Perkiraan pembayaran kembali",
  "originPrice": "Harga asli",
  "deliveryFee": "Kargo",
  "goodsFreight": "Kargo",
  "shippingDiscounts": "Diskon pengiriman",
  "homeIconTips3": "Diskon pengiriman",
  "desc6": "Masukkan kembali kata sandi transaksi Anda",
  "rebuy": "Satu pesanan lagi",
  "onlineService": "Pelayanan online",
  "customeService": "Layanan Pelanggan Daring",
  "helpLine": "Layanan Pelanggan Daring",
  "onlineApplin": "Lamar Daring",
  "暂无店铺": "Tidak ada toko yang ditemukan",
  "noComments": "Belum ada komentar",
  "noData": "Tidak ada data ditemukan",
  "帐户异常需要进行C3认证，请联系在线客服。": "Pengecualian akun memerlukan autentikasi C3. Silakan hubungi Layanan Pelanggan online.",
  "account": "Akun",
  "accountBalance": "Saldo rekening",
  "accountB": "Saldo rekening",
  "accountReview": "Ikhtisar Akun",
  "Recruitment": "Karier",
  "找不到用户": "Pengguna belum ditemukan",
  "searchTips": "Cari merek/produk/pemasok",
  "discount": "Diskon",
  "homeDownloadtips3": "Diskon tanpa henti",
  "discounted": "Diskon",
  "actualName": "Nama lengkap",
  "passPortImg": "Nomor ID/Paspor",
  "uploadId": "Unggah Foto ID/Paspor",
  "Payment": "Pembayaran",
  "pay": "Pembayaran",
  "paymentSuccessful": "Pembayaran berhasil",
  "paymentPending": "Pembayaran Tertunda",
  "paymentPendingDesc": "Pembayaran Anda sedang diproses. Silakan periksa status pesanan Anda nanti",
  "paymentMethod": "cara Pembayaran",
  "paymethods": "cara Pembayaran",
  "payCertificate": "Sertifikat Pembayaran",
  "直线关系，不能修改推荐": "Hubungan garis lurus, rekomendasi tidak dapat diubah",
  "tipsRemindsCount": "Hanya dapat diingatkan sekali",
  "committed": "Kami berdedikasi untuk menyediakan layanan pinjaman kepada pengusaha",
  "mediumOpinion": "Ulasan rata-rata",
  "sort": "Jenis",
  "重复提交": "Kirim ulang",
  "Reapply": "Melamar lagi",
  "register": "Daftar",
  "signUp": "Daftar",
  "registerSuccess": "Pendaftaran berhasil",
  "转账币种不能为空": "Bidang ini tidak boleh kosong",
  "转账数量不能小于等于0": "Jumlah transfer tidak boleh kurang dari atau sama dengan 0",
  "orderStatus": "Status",
  "orderState": "Status",
  "状态不能小于0": "Status tidak boleh kurang dari 0",
  "状态不是整数": "Status bukanlah bilangan bulat",
  "资金密码必须6-12位": "Kata sandi dana harus 6-12 karakter",
  "资金密码不符合设定": "Kata sandi dana tidak cocok",
  "资金密码不能为空": "Bidang ini tidak boleh kosong",
  "资金密码错误": "Kesalahan kata sandi dana",
  "资金密码长度不符合设定": "Panjang kata sandi tidak sesuai dengan pengaturan",
  "complex": "Menyimpulkan",
  "totalOf": "Total",
  "totalPrice": "Total harga",
  "homeBannertips3": "Maks.",
  "creditReview": "Lulus audit paling cepat dalam satu jam. Jika lolos peninjauan, pinjaman akan segera dicairkan.",
  "yesterday": "Kemarin",
  "binance": "binance",
  "huobi": "Huobi",
  "validatorIpRule": "Alamat IP salah",
  "获取验证码": "Mendapatkan kode verifikasi",
  "验证码": "Kode verifikasi",
  "请输入验证码": "Masukkan kode verifikasi",
  "发送": 
    "Kirim",
    "已发送，请注意查收":
    "Terkirim, segera cek",
  "metaMask": "MetaMask",
  "提现方式": "Metode penarikan",
  "footTip": "{name} Terbatas 2024. Semua Hak Dilindungi Undang-Undang.",
  "footTips": "{name} Limited diberi wewenang dan diatur oleh Financial Conduct Authority sebagai pialang kredit (713206) dan berhubungan secara eksklusif dengan pemberi pinjaman Home Retail Group CardServices Limited sebagai MetaShop Financial Services. {name} Jasa Keuangan diberi wewenang dan diatur oleh Financial Conduct Authority untuk memberikan kredit (716148). Home Retail GroupCard Services Limited terdaftar di Inggris (04007072) di Avebury, 489-499 Avebury Boulevard, Milton Keynes, Inggris. MK9 2NW.",
  "footdec": "{name} pengguna situs global berasal dari {num} negara di seluruh dunia dan menggunakan {coin} untuk penyelesaian. {coin} adalah transaksi tanpa batas yang memungkinkan transaksi langsung dan berbiaya rendah di seluruh dunia tanpa menunggu dan membebankan biaya internasional.",
  "okx": "okex",
  "客户端下载":
    "Unduh aplikasi",
  "备注": "Perkataan",
  "UID不能为空": "UID tidak boleh kosong",
  "滑动验证": "Seret penggeser untuk menyelesaikan teka-teki",
  "头像选择": "Pilih foto",
  "修改头像": "Mengubah",
  "银行卡": "Kartu bank",
  "平台人工发起退款": "Pengembalian dana yang dilakukan platform",
  "最多上传9张图片": "Unggah hingga 9 gambar",
  "账号注销": "Pembatalan akun",
  "确定注销": "Konfirmasikan pembatalan",
  "您的账号": "Akun Anda",
  "为什么要离开": "Mengapa kamu ingin pergi",
  "您还有余额,不能注销账号": "Anda masih memiliki saldo, Anda tidak dapat membatalkan akun Anda!",
  "请输入注销理由": "Silakan masukkan alasan pembatalan",
  "您确认要注销吗?": "Apakah Anda yakin ingin membatalkan?",
  "我再考虑下": "saya akan berpikir tentang hal ini",
  "同意注销": "Setuju untuk membatalkan",
  "注销成功": "Pembatalan berhasil",
  "请选择": "Silahkan pilih",
  "提款地址绑定": "Pengikatan alamat penarikan",
  "绑定成功": "Pengikatan berhasil",
  "仅能绑定一个收款地址!": "Hanya satu alamat yang dapat diikat!",
  "加值": "Tambahkan nilai",
  "提领": "Penarikan",
  "联系商家": "Hubungi penjual",
  "最多包含10位小数": "Hingga 10 tempat desimal",
  "企业电话":
    "Telepon perusahaan",
    "职业机会": 
    "Pekerjaan",
  "加密货币": "mata uang kripto",
  "参数缺失": "Parameter tidak ada",
  "充值数量必填": "Bidang ini tidak boleh kosong",
  "长时间未付款，系统自动取消订单": "Pembayaran tidak dilakukan dalam waktu yang lama, pesanan dibatalkan secara otomatis",
  "充值币种": "Mata uang setoran",
  "充值金额": "Jumlah setoran",
  "充值金额不得小于": "Jumlah Deposit tidak boleh kurang dari",
  "充值金额不得大于": "Jumlah Deposit tidak boleh lebih besar dari",
  "请先选择币种": "Silakan pilih mata uang terlebih dahulu",
  "开户行": "Bank",
  "请输入开户行名称": "Silakan masukkan nama bank",
  "银行卡号": "Nomor Kartu Bank",
  "请输入银行卡号": "Silakan masukkan nomor kartu bank",
  "点击去支付": "Klik untuk membayar",
  "企业证明": "Sertifikasi perusahaan",
  "footTipTikTok": "CoveBuy ©️2024 Hak Cipta",
  "TikTokFoot": "CoveBuy adalah platform sosial video pendek global CoveBuy dan perusahaan perdagangan grosir terbesar di Asia, Alibaba, yang didirikan melalui kerja sama. Ini adalah platform e-niaga global dan memiliki tiga gudang pintar yang dioperasikan sendiri di dunia, berlokasi di Toronto, Kanada, Los Angeles, dan Chiba, Jepang. Produk yang dijual di aplikasi ini meliputi produk populer dari Jepang, Korea Selatan, China, dan negara Asia lainnya. Saat ini, jumlahnya telah melampaui 50.000 dan terus bertambah pesat.",
  "cancelInfo": "Memperingatkan! Harap berhati-hati untuk membatalkan akun. Jika Anda tidak lagi menggunakan akun tersebut, Anda dapat mengklik [Setuju untuk Pembatalan]. Anda mungkin tidak dapat mendaftar dalam beberapa hari setelah pembatalan.",
  "betaBannerText": "Situs web dalam uji coba publik, harap jangan melakukan pemesanan"
}